import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import ProductCardStatic from 'components/consumer/ProductCardStatic';
import ProductCardGridUI from 'components/consumer/ProductCardGridUI';
import ProductCardStaticPlaceholder from 'components/consumer/ProductCardStaticPlaceholder';
import CardSlider from 'components/consumer/CardSlider';
import isStorybook from 'commons/isStorybook';
import useScreen from 'hooks/useScreen';

const LivestreamFeaturedProducts = ({ isAdmin = false, products = [] }) => {
  const { isMobileOrTablet } = useScreen();

  const isAdminOrStorybook = isAdmin || isStorybook();

  const productList = useMemo(
    () =>
      products?.map((product, index) => {
        if (isAdminOrStorybook) {
          return <ProductCardStaticPlaceholder />;
        }
        if (!product?.variantsToShow?.[0]?.sku) {
          return null;
        }
        return (
          <ProductCardStatic
            key={`${product?.id}-${product?.variantsToShow}`}
            layout="mini"
            name={product?.name}
            variantsToShow={product?.variantsToShow}
            secondaryImage={product?.secondaryImage}
            productLabel={product?.productLabel}
            position={index + 1}
          />
        );
      }),
    [isAdminOrStorybook, products]
  );

  return (
    <div className="lg:max-h-[calc((93.334vw_-_3rem_-_233px)_/16*9)] lg:overflow-auto min-[1500px]:max-h-[calc((1167px_-_3rem)_/16*9)]">
      {(isAdminOrStorybook || productList?.length > 0) && (
        <div className="text-lg font-bold text-gray-dark mt-6 pb-4 pl-5 pr-5 md:pl-[3.333vw] md:pr-[3.333vw] lg:bg-white lg:mt-0 lg:sticky lg:pb-2 lg:pl-0 lg:pr-0 lg:top-0 lg:z-[1]">
          Featured products
        </div>
      )}
      <div>
        {isMobileOrTablet ? (
          <div className="LivestreamFeaturedProducts__products__mobile">
            <CardSlider size="mini">{productList}</CardSlider>
          </div>
        ) : (
          <div className="pr-12 w-[233px]">
            <ProductCardGridUI
              columnsOnDesktop="1"
              columnsOnMobile="1"
              limitWidth={false}
            >
              {productList}
            </ProductCardGridUI>
          </div>
        )}
      </div>
    </div>
  );
};

LivestreamFeaturedProducts.propTypes = {
  products: PropTypes.array,
  isAdmin: PropTypes.bool,
};

export default LivestreamFeaturedProducts;
